import { useEffect, useState } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import SVG1_1 from '@/components/UI/svg/PowerOcean/App/SVG1_1';
import SVG1_2 from '@/components/UI/svg/PowerOcean/App/SVG1_2';
import SVG1_3 from '@/components/UI/svg/PowerOcean/App/SVG1_3';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.ef-app-pc-a .float-img1', { y: 100 }, { y: 0 }, 1],
                ['.ef-app-pc-a .float-img2', { y: 100 }, { y: 0 }, 2],
                ['.ef-app-pc-a .float-img3', { y: 200 }, { y: 0 }, 3],
                ['.ef-app-pc-a .float-img4', { y: 200 }, { y: 0 }, 4],
            ],
            asyncTimeLine: [0, 0, 0, 0],
            triggerElement: '.ef-app-pc-a',
            triggerHook: 1,
            offset: '20%',
            duration: '90%',
        });
        setTimeout(() => setIsEnter(true), 300);
    }, []);

    return (
        <div className={`ef-app-pc-a ${css.efAppPCA}`}>
            <div className="text-wrapper">
                <div className={`ani-text ${isEnter ? 'enter' : ''}`}>
                    <p className="sub-title">{t('sec1_subtitle')}</p>
                    <p className="title">{t('sec1_title')}</p>
                    <p className="desc">{t('sec1_desc')}</p>
                </div>

                <div className="icon-wrapper">
                    <div className="icon">
                        <SVG1_1 />
                        <p className="text">{t('sec1_icon1')}</p>
                    </div>
                    <div className="icon">
                        <SVG1_2 />
                        <p className="text">{t('sec1_icon2')}</p>
                    </div>
                    <div className="icon">
                        <SVG1_3 />
                        <p className="text">{t('sec1_icon3')}</p>
                    </div>
                </div>
            </div>
            <div className="img-wrapper">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/kv.webp')}
                    src={require('@publicLocal/power-ocean/app/kv.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>

            <div className="float-img float-img1">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/1-1.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/1-1.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>

            <div className="float-img float-img2">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/1-2.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/1-2.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>

            <div className="float-img float-img3">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/1-3.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/1-3.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>

            <div className="float-img float-img4">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/1-4.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/1-4.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>
        </div>
    );
}
